
import {
  Component,
  Vue
  // Prop,
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import { objAny } from "../../common/common-interface";
import i18n from "@/config/i18n";
@Component
export default class PiSysContent extends Vue {
  @State("sys") sys!: objAny;
  @Mutation("UP_GOROUTER") UP_GOROUTER!: Function;

  private tagList: object[] = [{ name: i18n.t("user.userManagement") }];
  public handleClose(item: objAny, index: number): void {
    if (this.sys.toData.path == item.url) {
      let url = "";
      if (index === 0) {
        url = this.sys.goRouter[index + 1].url;
      } else {
        url = this.sys.goRouter[index - 1].url;
      }
      this.$router.push(url);
    }
    this.UP_GOROUTER(index);
  }
  // mounted() {}
}
